import { useFetchWrapper } from './fetch-wrapper'

const useIntakeAlertService = () => {

  const fetchWrapper = useFetchWrapper()

  const GetAlert = async () => {
    return fetchWrapper.get(`intakealert`)
  }

  return { GetAlert }
}

export { useIntakeAlertService };